<template>
  <div class="page-wrapper">
    <div class="page-header">
      <WidgetToolbar :back="true" title="Accounts" :icon="require('@/assets/icon/accounts-active.svg')"
        @onBack="$navigationGoBack('/accounts')">
        <div class="options">
          <!-- <widgetButton
            v-if="account"
            @click="show_add_internship_modal = true"
            :loading="false"
            class="btn-secondary"
          >
            Generate Assignment +
          </widgetButton> -->
        </div>
      </WidgetToolbar>
    </div>
    <div class="page-tab">
      <div class="page-path-widget">
        <img @click="$router.push({ path: '/accounts' })" src="@/assets/icon/accounts-active.svg" class="icon" />
        <label @click="$router.push({ path: '/accounts' })" class="path-name link">Accounts</label>
        <img src="@/assets/icon/outline-carret-green.svg" class="allow" />
        <label class="path-name"> {{ account.name }} </label>
      </div>

      <div class="page-tab-options row">
        <widgetButton :loading="false" @click="getStartData()" class="btn-transparent fit-content">
          <img src="@/assets/icon/reflesh-gray.svg" />
        </widgetButton>
      </div>
    </div>
    <div class="page-body">
      <accountSidebar switch_tab="overview" :account="account"></accountSidebar>
      <div class="company-profile-wrapper">
        <!-- company-profile display -->
        <div class="company-profile-container" v-animate-css="'fadeIn'">
          <div class="company-profile-header">
            <div class="account-profile">
              <div class="account-category">Gold</div>
              <div class="account-details">
                <div class="name">{{ account.name | validate }}</div>
                <div v-if="false" class="account-email-phone">
                  {{ account.phone | validate }}
                  {{ account.email ? " | " : "" }}
                  {{ account.email | validate }}
                </div>
                <div class="location-data">
                  {{ account.location | validate }}
                </div>
              </div>

              <div class="account-status" :class="account_status">
                {{
                  account_status == "active"
                  ? "Active"
                  : account_status == "passive"
                    ? "Passive"
                    : account_status == "onhold"
                      ? "On Hold"
                      : ""
                }}
              </div>
            </div>

            <div class="company-profile-brand">
              <p class="company-desc" v-if="account.description" v-html="account.description"></p>
              <div class="company-profile-option">
                <button class="edit-btn" @click="updateAccount(account)">
                  Edit Account
                  <img class="img-icon" src="@/assets/icon/edit-gray.svg" />
                </button>
              </div>
            </div>
            <div class="company-profile-options"></div>
          </div>
          <div class="company-profile-body" style="margin-bottom: 10px">
            <ul class="contact-items" v-if="account.contacts && account.contacts.length > 0">
              <li class="contact-starter">
                <div class="contact-item-header">
                  <label>Contacts</label>
                </div>
              </li>
              <li class="contact-item" v-for="(item, index) in account.contacts" :key="index">
                <div class="contact-item-header">
                  <div class="contact-item-brand">
                    <widgetProfile :title="item.first_name + ' ' + item.last_name" subtitle="" file_name="" path="">
                    </widgetProfile>
                  </div>
                  <div class="phone">
                    <span>{{ item.phone_alt | validate }}</span>
                  </div>
                  <div class="email">
                    <span>{{ item.email | validate }}</span>
                  </div>
                  <div class="comment">
                    <div v-if="item.contact_type == 'company_contact'" class="is-student-contact">
                      Assignment Contact
                    </div>
                    <div v-if="item.contact_type == 'account_contact'" class="is-account-contact">
                      Account Contact
                    </div>
                  </div>
                  <div class="option">
                    <dropdownMenu>
                      <ul>
                        <li>
                          <a @click="updateContact(item)">Update</a>
                        </li>
                        <li>
                          <app-dialog title="Delete Contact" ask="Are you sure you want to delete this contact?"
                            yesText="Delete" noText="Cancel" @onComfirm="deleteContact(item.id)">
                            <a>Delete Contact</a>
                          </app-dialog>
                        </li>
                      </ul>
                    </dropdownMenu>
                  </div>
                </div>
              </li>
            </ul>
            <div class="empty-widget" v-else>
              <div class="empty-widgetheader">
                <label>Contacts</label>
              </div>
              <div class="empty-widget-body">
                <p>
                  You have not yet added any contact
                  <br />Click below to add one
                </p>
                <widgetButton :loading="false" @click="selectTab('contacts')" class="btn-secondary">
                  Add a Contact
                </widgetButton>
              </div>
            </div>
          </div>
          <div class="company-profile-body">
            <ul class="project-items" v-if="projects.length > 0">
              <li class="project-starter">
                <div class="project-item-header">
                  <label>Project</label>
                </div>
              </li>
              <li class="project-item" v-for="(item, i) in projects.slice(0, 5)" :key="i">
                <div class="project-item-header">
                  <div class="project-item-brand">
                    <img src="@/assets/icons/projects_icon.svg" alt />
                  </div>
                  <div class="content">
                    <div class="title-row">
                      <label>{{ item.name | validate }}</label>
                      <span v-if="item.address">{{
                        item.address | validate
                      }}</span>

                      <span class="date">
                        <span v-if="item.from">{{
                          item.from | formatDate | validate
                        }}</span>
                        <span class="separator" v-if="item.from && item.to">-</span>
                        <span v-if="item.to">{{
                          item.to | formatDate | validate
                        }}</span>
                      </span>
                    </div>
                    <div class="options">
                      <div class="btns">
                        <span v-if="item.verified" class="verified-status">Verified</span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="empty-widget" v-else>
              <div class="empty-widgetheader">
                <label>Projects</label>
              </div>
              <div class="empty-widget-body">
                <p>
                  You have not yet added any project
                  <br />Click below to add one
                </p>
                <widgetButton :loading="false" @click="selectTab('projects')" class="btn-secondary">
                  Add a Project
                </widgetButton>
              </div>
            </div>
          </div>
        </div>
        <!-- End -->
      </div>
      <!-- Lead and Task widget -->
      <div class="lead-task-section">
        <div class="widget-container" v-if="account.tasks && account.tasks.length > 0">
          <div class="container-header">
            <h3>Tasks</h3>
            <button class="btn-view-all" @click="$router.push({ name: 'task' })">
              View All
            </button>
          </div>
          <div class="widget-body">
            <div v-for="(task, i) in account.tasks.slice(0, 5)" :key="i" class="card" @click="
              $router.push({
                name: 'task',
                params: { id: task.id },
              })
              ">
              <div class="card-header">
                <div class="title">
                  {{ task.name | validate }}
                </div>
                <div class="card-type">
                  <label :style="{ color: getColor(task.type) }">{{
                    task.type | validate
                  }}</label>
                  <div :style="{ 'background-color': getColor(task.type) }" class="type-box"></div>
                </div>
              </div>
              <div class="compang-widget">
                <span class="company-name">{{ account.name | validate }}</span>
                <div class="company-contact" v-if="task.contacts.length > 0">
                  <template v-for="(contact, index) in task.contacts">
                    <span :key="index" v-if="index == 0">
                      {{ contact.first_name | validate }}
                      {{ contact.last_name | validate }}
                    </span>
                  </template>
                  <div v-if="task.contacts.length > 1" class="other-contact">
                    , & {{ (task.contacts.length - 1) | validate }} more
                    contacts
                  </div>
                </div>
              </div>
              <div class="members">
                <div class="member" v-for="(member, index) in task.assignees" :key="index">
                  <assingProfileToolTip :member="member">
                    <img v-if="member.profile_picture" :src="$fullUrl('images/profiles/' + member.profile_picture)
                      " :class="{ override: index > 0 }" />
                    <img v-else :class="{ override: index > 0 }" src="@/assets/avatar.png" />
                  </assingProfileToolTip>
                  <span v-if="task.assignees.length == 1" class="name">{{
                    (member.first_name + " " + member.last_name) | validate
                  }}</span>
                </div>
              </div>
              <div class="due-date" v-if="task.due_date">
                {{
                  moment(task.due_date).format("ddd, DD MMM YYYY") | validate
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="widget-container" v-if="account.leads && account.leads.length > 0">
          <div class="container-header">
            <h3>Leads</h3>
            <button class="btn-view-all" @click="$router.push({ name: 'leads' })">
              View All
            </button>
          </div>
          <div class="widget-body">
            <div v-for="(lead, i) in account.leads.slice(0, 5)" :key="i" class="lead-card" @click="
              $router.push({
                name: 'leads',
                params: { id: lead.id },
              })
              ">
              <div class="card-header"></div>
              <div class="title-widget">
                <span class="lead-name">{{ lead.name | validate }}</span>
              </div>
              <div class="compang-widget">
                <span class="company-name">
                  {{ account.name | validate }}
                </span>

                <div class="company-contact" v-if="lead.contacts && lead.contacts.length > 0">
                  <template v-for="(contact, index) in lead.contacts">
                    <span :key="index" v-if="index == 0">
                      {{ contact.first_name | validate }}
                      {{ contact.last_name | validate }}
                    </span>
                  </template>
                  <div v-if="lead.contacts.length > 1" class="other-contact">
                    , & {{ (lead.contacts.length - 1) | validate }} more
                    contacts
                  </div>
                </div>
              </div>

              <div class="members">
                <div class="member" v-for="(member, index) in lead.assignees" :key="index">
                  <assingProfileToolTip :member="member">
                    <img v-if="member.profile_picture" :src="$fullUrl('images/profiles/' + member.profile_picture)
                      " :class="{ override: index > 0 }" />
                    <img v-else :class="{ override: index > 0 }" src="@/assets/avatar.png" />
                  </assingProfileToolTip>
                  <span v-if="lead.assignees.length == 1" class="name">{{
                    (member.first_name + " " + member.last_name) | validate
                  }}</span>
                </div>
              </div>
              <div class="price">{{ lead.value | validate }} USD</div>
            </div>
          </div>
        </div>


      </div>
    </div>


    <!-- Add - Update Modal -->
    <addUpdateAccountModal v-if="show_form_add_update" :content="selected_account" @success="submitAccountData()"
      @close="show_form_add_update = false" @onGenerateInternship="onAddInternship"></addUpdateAccountModal>

    <!-- Add - Update Modal -->
    <addUpdateContactModal v-if="show_contact_form_add_update" :content="selected_contact" @success="contactSaved()"
      @close="show_contact_form_add_update = false"></addUpdateContactModal>
  </div>
</template>

<script>
import accountSidebar from "@/views/Accounts/components/account_sidebar.vue";
import addUpdateAccountModal from "@/views/Accounts/components/add_update_account_modal.vue";
import addUpdateContactModal from "@/views/Accounts/components/add_update_contact_modal.vue";
import { eventBus } from "@/main";

export default {
  name: "genelar-info-profile",
  components: {
    accountSidebar,
    addUpdateAccountModal,
    addUpdateContactModal,
  },
  props: {},
  data: () => {
    return {
      show_add_internship_modal: false,
      show_form_add_update: false,
      accounts_for_internship: {},
      account: {},
      projects: [],
      account_status: "",
      account_form: {
        id: null,
        account_id: null,
        name: "",
        description: "",
        responsible: "",
        phone: "",
        email: "",
        location: "",
        tags: [],
        corporate_identity: "",
        vat_number: "",
      },
      adding_acc_loading: false,
      task_types: [
        {
          name: "Task",
          color: "#0884AF",
        },
        {
          name: "Follow up",
          color: "#1BA5A4",
        },
        {
          name: "Call",
          color: "#FFC273",
        },
        {
          name: "Mail",
          color: "#9FD076",
        },
        {
          name: "Meeting",
          color: "#ACAF5C",
        },
        {
          name: "Other",
          color: "#ED6400",
        },
      ],
      internships: [],
      selected_contact: null,
      show_contact_form_add_update: false,
    };
  },
  mounted() {
    let vm = this;
    vm.getStartData();
    vm.getProjectsData();
  },
  computed: {},
  methods: {
    internshipIsNowAdded() {
      let vm = this;
      vm.getAccountInternship(vm.$route.params.id);
      vm.show_add_internship_modal = false;
    },
    contactSaved() {
      let vm = this;
      vm.selected_contact = null;
      vm.show_contact_form_add_update = false;
      vm.getStartData();
    },
    updateContact(item) {
      let vm = this;
      eventBus.$set(item, "account", vm.account);
      vm.selected_contact = item;
      vm.show_contact_form_add_update = true;
    },
    deleteContact(id) {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_CONTACT_DELETE", { contact_id: id })
        .then((response) => {
          vm.getStartData();
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    getColor(val) {
      let vm = this;
      let color = "";
      vm.task_types.forEach((item) => {
        if (item.name == val) {
          color = item.color;
        }
      });
      return color;
    },
    updateAccount(item) {
      let vm = this;
      vm.selected_account = item;
      vm.show_form_add_update = true;
    },
    submitAccountData() {
      let vm = this;
      vm.getStartData();
      vm.show_form_add_update = false;
    },
    onAddInternship(payload) {
      let vm = this;
      vm.show_form_add_update = false;
      payload.origin = "account";
      vm.accounts_for_internship = payload;
      vm.getStartData();
      vm.show_add_internship_modal = true;
    },
    selectTab(type) {
      let vm = this;
      vm.$router
        .push({
          name: "account-view",
          params: { type: type, id: vm.$route.params.id },
        })
        .catch((error) => { });
    },
    getProjectsData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("ACCOUNT_PROJECT_GET_ALL", {
          account_id: parseInt(vm.$route.params.id),
        })
        .then((responce) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.projects = vm.processSkills(responce.data);
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
        });
    },
    getStartData() {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_SINGLE_GET_ALL_DATA", {
          account_id: vm.$route.params.id,
        })
        .then((responce) => {
          vm.account = responce.data;
          vm.accounts_for_internship = {
            type: "many",
            accounts: [vm.account],
          };
          vm.selected_accounts = vm.account;
          vm.getAccountInternship(vm.$route.params.id);
          vm.account_status = responce.data.status;
        })
        .catch((error) => { });
    },
    getAccountInternship(id) {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_SINGLE_GET_INTERNSHIP", {
          account_id: id,
        })
        .then((responce) => {
          vm.internships = responce.data.map((item) => {
            item.expanded = false;
            return item;
          });
        })
        .catch((error) => { });
    },
    onStatusChanged(item) {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_CHANGE_STATUS", {
          account_id: vm.$route.params.id,
          status: item.value,
        })
        .then((responce) => {
          vm.account_status = item.value;
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Account status is now updated",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    processSkills(obj) {
      return obj.map((item) => {
        let skills = {
          tools: [],
          domains: [],
          languages: [],
          competences: [],
          roles: [],
        };
        let skills_data = [];
        if (item.skills && item.skills.length > 0) {
          item.skills.forEach((skill) => {
            skill.tools.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.tools.push(obj);
            });
            skill.domains.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.domains.push(obj);
            });
            skill.competences.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.competences.push(obj);
            });
            skill.roles.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.roles.push(obj);
            });
            skill.languages.forEach((item) => {
              if (item.lang) {
                let obj = {
                  lang: { name: item.lang.name },
                  level: parseInt(item.level),
                };
                skills.languages.push(obj);
              }
            });
          });
        }
        eventBus.$set(item, "skills_data", item.skills);
        eventBus.$set(item, "skills", skills);

        return item;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  padding: 5px;

  .page-header {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;

    .options {
      display: flex;
      align-items: center;

      .search-account {
        width: 250px;
        height: 45px;
      }

      .btn-add {
        margin-left: 20px;
        width: 130px;
      }
    }
  }

  .page-tab {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;

    .page-path-widget {
      display: flex;
      align-items: center;

      .icon {
        width: 15px;
        margin-top: -3px;
        margin-right: 10px;
        cursor: pointer;
      }

      .allow {
        margin: 0px 10px;
      }

      .path-name {
        color: #1ba5a4;
        font-size: 12px;

        &.link {
          cursor: pointer;
        }
      }
    }
  }

  .page-body {
    height: calc(100% - 73px);
    display: flex;

    .company-profile-wrapper {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      width: calc(100% - 495px);
      margin-right: 5px;

      .company-profile-container {
        height: 100%;
        overflow-y: auto;
        padding-bottom: 20px;

        @media (min-width: 300px) and (max-width: 630px) {
          height: unset;
          overflow-y: unset;
          padding-bottom: 10px;
        }

        .company-profile-header {
          padding: 20px 20px;
          border-radius: 5px;
          background: #ffffff;
          margin-bottom: 5px;
          position: relative;

          .account-profile {
            display: flex;
            align-items: start;
            justify-content: space-between;

            .account-category {
              color: #c4c4c4;
            }

            .account-details {
              display: flex;
              flex-direction: column;
              align-items: center;

              .name {
                margin-bottom: 10px;
                color: #000000;
                font-size: 20px;
                text-transform: capitalize;
              }

              .account-email-phone {
                margin-bottom: 10px;
              }

              .location-data {
                color: #707070;
              }
            }

            .account-status {
              &.active {
                color: #007d7c;
              }

              &.passive {
                color: #0884af;
              }
            }
          }

          .company-profile-brand {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            @media (min-width: 300px) and (max-width: 630px) {
              border-radius: 4px;
              border: 1px solid #ddd;
              padding: 15px;
            }

            .location-data,
            .contact-data {
              .separator {
                margin: 0px 20px;
              }
            }

            span {
              font-size: 14px;
              margin-bottom: 10px;
            }

            p.company-desc {
              font-size: 12px;
              line-height: 20px;
              text-align: justify;

              @media (min-width: 300px) and (max-width: 630px) {
                text-align: left;
              }
            }

            .company-profile-option {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;

              .edit-btn {
                background: #ffffff 0% 0% no-repeat padding-box;
                border: 1px solid #ddd;
                border-radius: 5px;
                padding: 6px 9px;
                font-size: 12px;
                margin-top: 13px;
                color: #646262;
                cursor: pointer;
                outline: none;
                width: max-content;
                border: 1px solid #ccc;
                display: flex;
                align-items: center;

                .img-icon {
                  width: 14px;
                  margin-left: 10px;
                }
              }
            }
          }

          .company-profile-options {
            .btn-edit-info {
              box-shadow: 0px 1px 3px #00000029;
              border: 1px solid #36adae;
              border-radius: 5px;
              color: #1885ad;
              padding: 10px 50px;
            }
          }
        }

        .company-profile-body {
          padding: 20px;
          border-radius: 5px;
          background: #ffffff;

          ul.contact-items {
            padding-left: 0px;
            list-style: none;
            margin: 0px;

            .contact-starter {
              margin-bottom: 6px;

              .contact-item-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-bottom: 20px;

                label {
                  color: #000000;

                  font-size: 16px;
                }

                .btn-add-assignment {
                  color: #1ba5a4;
                  border: none;
                  padding: 10px 10px;
                  font-size: 14px;
                  outline: none;
                  cursor: pointer;

                  font-style: italic;
                  background: transparent;
                }
              }

              p {
                color: #131313;
              }
            }

            .contact-item {
              background: #f0f0f0;
              border-radius: 10px;
              margin-bottom: 10px;

              .contact-item-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 17px 17px;

                .contact-item-brand {
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  width: 100%;

                  img {
                    width: 60px;
                    height: 60px;
                    object-fit: cover;
                    margin-right: 15px;
                    border-radius: 50%;
                  }
                }

                .phone {
                  width: 100%;
                }

                .email {
                  width: 100%;
                }

                .comment {
                  width: 100%;
                }
              }

              .contact-item-body {
                padding: 10px;

                h4 {}

                img {
                  width: 100%;
                }

                p {
                  font-size: 14px;
                }

                label {
                  color: #808080;
                  font-size: 15px;
                  display: block;
                  margin-bottom: 8px;
                }

                .skills-widget {
                  display: flex;
                  flex-wrap: wrap;

                  .skill-item {
                    background: #707070 0% 0% no-repeat padding-box;
                    border-radius: 25px;
                    color: #ffffff;
                    font-size: 13px;

                    padding: 5px 22px;
                    margin-right: 10px;
                    margin-bottom: 10px;
                  }
                }

                .contact-info {
                  display: flex;
                  justify-content: space-between;
                  margin-top: 20px;

                  .col-one,
                  .col-two {
                    width: 50%;

                    label {
                      color: #808080;
                      margin-bottom: 3px;
                      margin-top: 20px;
                    }

                    p {
                      color: #000;
                      margin: 0px;
                    }
                  }
                }
              }
            }
          }

          .empty-widget {
            .empty-widget-body {
              height: 225px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;

              h1 {
                margin-bottom: 30px;
              }

              p {
                text-align: center;
                width: 270px;
              }
            }
          }
        }

        .company-profile-body {
          padding: 20px;
          border-radius: 5px;
          background: #ffffff;

          ul.project-items {
            padding-left: 0px;
            list-style: none;

            .project-starter {
              margin-bottom: 6px;

              .project-item-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 16px 0px;

                label {
                  color: #000000;

                  font-size: 16px;
                }

                .btn-add-assignment {
                  color: #1ba5a4;
                  border: none;
                  padding: 10px 10px;
                  font-size: 14px;
                  outline: none;
                  cursor: pointer;

                  font-style: italic;
                  background: transparent;
                }
              }

              p {
                color: #131313;
              }
            }

            .project-item {
              background: #f5f5f5 0% 0% no-repeat padding-box;
              border-radius: 5px;
              margin-bottom: 10px;

              .project-item-header {
                display: grid;
                padding: 7px;
                grid-template-columns: 70px calc(98% - 90px);
                grid-column-gap: 10px;

                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 100%;
                  padding: 10px 12px;
                }

                .project-item-brand {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 70px;
                  height: 70px;
                  background: rgb(228, 228, 228);
                  border-radius: 50%;

                  @media (min-width: 300px) and (max-width: 630px) {
                    width: 60px;
                    height: 60px;
                    display: none;
                  }

                  img {
                    width: 50px;
                    height: 50px;
                    object-fit: contain;

                    @media (min-width: 300px) and (max-width: 630px) {
                      width: 33px;
                      height: 33px;
                    }
                  }
                }

                .content {
                  display: flex;
                  justify-content: space-between;

                  .title-row {
                    padding-right: 9px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    label {
                      display: block;
                      font-size: 13px;
                      margin-bottom: 1px;

                      @media (min-width: 300px) and (max-width: 630px) {
                        font-size: 12px;
                      }
                    }

                    span {
                      color: #808080;
                      font-size: 11px;
                      margin-bottom: 4px;

                      @media (min-width: 300px) and (max-width: 630px) {
                        font-size: 12px;
                      }
                    }

                    .date {
                      color: #808080;
                      font-size: 11px;
                      display: flex;
                      justify-content: flex-start;
                      align-items: center;

                      .separator {
                        margin: 0px 5px;
                      }

                      @media (min-width: 300px) and (max-width: 630px) {
                        font-size: 11px;
                      }
                    }
                  }

                  .options {
                    display: flex;
                    align-items: flex-end;
                    flex-direction: column;

                    .btns {
                      display: flex;
                      margin-top: -5px;

                      .verified-status {
                        color: #0590ab;
                        margin: 10px 0px;
                      }

                      .btn-verify {
                        height: 40px;
                        width: 100px;
                        outline: none;
                        color: #fff;
                        background-color: #1890a9;
                        border-radius: 5px;
                      }
                    }

                    .status {
                      color: #000;

                      font-size: 13px;
                    }

                    .toogle-panel-btn {
                      width: 19px;
                      padding: 0;
                      height: 22px;
                      font-size: 20px;
                      position: absolute;
                      bottom: 5px;
                      right: 7px;
                    }
                  }
                }

                .toogle-panel-btn {
                  padding: 1px 40px;
                  font-size: 30px;
                  background: transparent;
                  border: none;
                  outline: none;
                  cursor: pointer;
                  color: #ccc;
                }
              }

              .project-item-body {
                padding: 10px;

                h4 {}

                img {
                  width: 100%;
                }

                p {
                  font-size: 14px;
                }

                label {
                  color: #808080;
                  font-size: 15px;
                  display: block;
                  margin-bottom: 8px;
                }

                .skills-widget {
                  display: flex;
                  flex-wrap: wrap;

                  .skill-item {
                    background: #707070 0% 0% no-repeat padding-box;
                    border-radius: 25px;
                    color: #ffffff;
                    font-size: 13px;

                    padding: 5px 22px;
                    margin-right: 10px;
                    margin-bottom: 10px;
                  }
                }

                .project-info {
                  display: flex;
                  justify-content: space-between;
                  margin-top: 20px;

                  .col-one,
                  .col-two {
                    width: 50%;

                    label {
                      color: #808080;
                      margin-bottom: 3px;
                      margin-top: 20px;
                    }

                    p {
                      color: #000;
                      margin: 0px;
                    }
                  }
                }
              }
            }
          }

          .empty-widget {
            .empty-widget-body {
              height: 225px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              padding: 0px 200px;

              p {
                text-align: center;
              }
            }
          }
        }
      }
    }

    .lead-task-section {
      border-radius: 5px;
      height: 100%;
      width: 350px;
      overflow-y: auto;
      padding-bottom: 70px;

      .widget-container {
        background: #ffffff;
        padding: 10px 10px;
        margin-bottom: 10px;
        border-radius: 10px;

        .container-header {
          display: flex;
          justify-content: space-between;
          padding: 15px 0px;

          h3 {
            font-size: 17px;
            margin: 0px;
          }

          .btn-view-all {
            color: #0884af;
          }
        }

        .widget-body {
          .card {
            width: 100%;
            background: #f5f5f5;
            position: relative;
            padding: 8px 8px;
            border-radius: 10px;
            margin-bottom: 10px;
            min-height: 72px;

            .card-header {
              display: flex;
              justify-content: space-between;
              margin-bottom: 5px;
              width: 100%;

              .title {
                font-size: 17px;
                color: #000;
                overflow: hidden;
                text-decoration: none;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 115px;
              }

              .card-type {
                display: flex;
                align-items: center;
                justify-content: flex-end;

                label {
                  font-size: 10px;
                  white-space: nowrap;
                  text-align: right;
                }

                .type-box {
                  height: 15px;
                  width: 15px;
                  border-radius: 2px;
                  margin-left: 5px;
                }
              }
            }

            .compang-widget {
              display: flex;
              flex-direction: column;
              padding-right: 20px;

              .company-name {
                color: #707070;
                margin-bottom: 5px;
              }

              .company-contact {
                display: flex;
                align-items: center;
                margin-bottom: 5px;

                span {
                  font-size: 12px;
                  white-space: nowrap;
                }

                .other-contact {
                  color: #ccc;
                  font-size: 12px;
                  white-space: nowrap;
                }
              }
            }

            .members {
              display: flex;

              .member {
                display: flex;
                align-items: center;

                img {
                  width: 20px;
                  height: 20px;
                  object-fit: cover;
                  margin-right: 4px;
                  border-radius: 50%;
                  border: 2px solid #fff;

                  &.override {
                    margin-left: -10px;
                  }
                }

                .name {
                  background: #06a1a11f;
                  padding: 2px 5px;
                  border-radius: 15px;
                  font-size: 11px;
                  color: #04a5a5;
                  display: block;
                }
              }
            }

            .due-date {
              position: absolute;
              bottom: 10px;
              right: 15px;
              font-size: 10px;
            }

            &.hold {
              border: solid#04a5a5 1px;
              border-radius: 5px;
            }

            &.invisible {
              opacity: 0.5;
            }
          }

          .lead-card {
            width: 100%;
            background: #f5f5f5;
            position: relative;
            padding: 15px 15px;
            cursor: pointer;
            border-radius: 10px;
            margin-bottom: 10px;

            &:hover {
              .card-header {
                .card-checkbox {
                  display: block;
                }
              }
            }

            .card-header {
              display: flex;
              justify-content: flex-end;
              position: absolute;
              right: 2px;
              top: 8px;

              .card-checkbox:checked {
                display: block;
              }

              .card-checkbox {
                display: none;
              }
            }

            .title-widget {
              margin-bottom: 5px;

              .lead-name {
                font-size: 16px;
                color: #000;
                overflow: hidden;
                text-decoration: none;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 115px;
              }
            }

            .compang-widget {
              display: flex;
              justify-content: space-between;
              padding-right: 20px;

              .company-name {
                color: #0884af;
              }

              .company-contact {
                display: flex;
                align-items: center;
                margin-bottom: 5px;

                span {
                  font-size: 12px;
                  white-space: nowrap;
                }

                .other-contact {
                  color: #ccc;
                  font-size: 12px;
                  white-space: nowrap;
                }
              }
            }

            .members {
              margin-top: 5px;
              display: flex;

              .member {
                display: flex;
                align-items: center;

                img {
                  width: 20px;
                  height: 20px;
                  object-fit: cover;
                  margin-right: 4px;
                  border-radius: 50%;
                  border: 2px solid #fff;

                  &.override {
                    margin-left: -10px;
                  }
                }

                .name {
                  background: #06a1a11f;
                  padding: 2px 5px;
                  border-radius: 15px;
                  font-size: 11px;
                  color: #04a5a5;
                  display: block;
                }
              }
            }

            .price {
              color: rgb(134, 134, 134);
              position: absolute;
              bottom: 18px;
              right: 15px;
              font-size: 10px;
            }

            .attachment {
              width: 100%;
              padding: 0px 10px;

              img {
                width: 100%;
                height: 70px;
                object-fit: cover;
                border-radius: 20px;
              }
            }
          }

          ul.assignments-items {
            list-style: none;
            padding-left: 0px;
            margin: 0px;

            @media (min-width: 300px) and (max-width: 630px) {
              padding: 0px 0px;
            }

            .assignments-item {
              background: #f8f8f8;
              border-radius: 10px;
              margin-bottom: 10px;
              position: relative;
              cursor: pointer;
              border: none;

              @media (min-width: 300px) and (max-width: 630px) {
                padding: 0px 0px;
              }

              &.active {
                background: #1885ad15;
              }

              .inter-check {
                position: absolute;
                top: 4px;
                left: 3px;
              }

              .assignments-item-header {
                display: flex;
                align-items: center;
                padding: 10px 14px;

                .assignments-item-brand {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 60px;
                  height: 60px;

                  @media (min-width: 300px) and (max-width: 630px) {
                    width: 60px;
                    height: 60px;
                  }

                  img {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    object-fit: cover;

                    @media (min-width: 300px) and (max-width: 630px) {
                      width: 50px;
                      height: 50px;
                    }
                  }
                }

                .content {
                  display: flex;
                  width: 100%;
                  padding-right: 5px;
                  padding-left: 10px;
                  justify-content: space-between;
                  align-items: flex-start;
                  padding-top: 6px;

                  .title-row {
                    width: 100%;

                    label {
                      font-size: 18px;
                      color: #000;
                      margin-bottom: 3px;
                      overflow: hidden;
                      text-decoration: none;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      width: 100%;
                      display: block;
                    }

                    p.company {
                      margin: 0px;
                      font-size: 16px;
                      margin-bottom: 3px;
                      overflow: hidden;
                      text-decoration: none;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      width: 100%;
                      display: block;
                      color: #6c6c6c;
                    }

                    p.location {
                      color: #1ba5a4;
                      margin: 0px;
                      margin-bottom: 3px;
                      font-size: 14px;
                      overflow: hidden;
                      text-decoration: none;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      width: 100%;
                      display: block;
                    }

                    p.date {
                      color: #6c6c6c;
                      margin: 0px;
                      margin-bottom: 3px;
                      font-size: 14px;
                      overflow: hidden;
                      text-decoration: none;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      width: 100%;
                      display: block;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.input-flex {
  display: flex;
}
</style>